import { useState, type CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

const FAQ_KEYS = ['price', 'warranty', 'shipping', 'battery', 'refurbished'] as const

export default function TrustFaqSection() {
  const { t } = useTranslation()
  const [openKey, setOpenKey] = useState<(typeof FAQ_KEYS)[number] | null>(null)

  function toggleFaq(key: (typeof FAQ_KEYS)[number]) {
    setOpenKey((current) => (current === key ? null : key))
  }

  return (
    <section className="vc-section vc-section--centered vc-section--faq" aria-labelledby="vc-faq-heading">
      <h3 id="vc-faq-heading" className="vc-section-title">
        {t('trust.faq.heading')}
      </h3>
      <div className="vc-faq-list">
        {FAQ_KEYS.map((key, faqIdx) => {
          const open = openKey === key
          return (
            <article
              key={key}
              className={`vc-faq-item${open ? ' vc-faq-item--open' : ''}`}
              style={{ '--faq-i': faqIdx } as CSSProperties}
            >
              <button
                type="button"
                className="vc-faq-item__head"
                aria-expanded={open}
                onClick={() => toggleFaq(key)}
              >
                <span className="vc-faq-item__q">{t(`trust.faq.${key}Q`)}</span>
                <span className="vc-faq-item__toggle" aria-hidden="true" />
              </button>
              <div className={`vc-faq-item__panel${open ? ' vc-faq-item__panel--open' : ''}`}>
                <div className="vc-faq-item__panel-inner">
                  <p className="vc-faq-item__a">{t(`trust.faq.${key}A`)}</p>
                </div>
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}
